import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCog } from 'react-icons/fa';
import AdminSettings from './AdminSettings';
import ApprovalFlow from './ApprovalFlow';
import AlertsNotifications from './AlertsNotifications';
import AIProviders from './AIProviders';
import BackupRestore from './BackupRestore';
import ReportProfilesEditor from '../components/ReportProfilesEditor';
import CleanabilityAssessmentConfigEditor from '../components/CleanabilityAssessmentConfigEditor';
import CompanyUnitsEditor from '../components/CompanyUnitsEditor';

// Settings → App Configuration (LMS-style): every app-wide setting on one page,
// one tab per area. Commercial Setup (plan, modules, limits, license, hard
// reset) stays a separate page, as in the LMS. ?tab=<key> opens a tab.
const TABS = [
  { key: 'general', label: 'General', render: () => <AdminSettings section="general" /> },
  { key: 'company', label: 'Company & Units', render: () => <CompanyUnitsEditor /> },
  {
    key: 'masters',
    label: 'Master Data Rules',
    render: () => (
      <>
        <AdminSettings section="masters" />
        <CleanabilityAssessmentConfigEditor />
      </>
    ),
  },
  { key: 'compliance', label: 'Compliance', render: () => <AdminSettings section="compliance" /> },
  {
    key: 'reports',
    label: 'Reports & Document Numbering',
    render: () => (
      <>
        <ReportProfilesEditor />
        <AdminSettings section="reports" />
      </>
    ),
  },
  { key: 'permissions', label: 'Roles & Permissions', render: () => <AdminSettings section="permissions" /> },
  { key: 'approval', label: 'Approval Flow', render: () => <ApprovalFlow /> },
  { key: 'alerts', label: 'Alerts & Notifications', render: () => <AlertsNotifications /> },
  { key: 'access', label: 'Access & Devices', render: () => <AdminSettings section="access" /> },
  { key: 'ai', label: 'AI Providers', render: () => <AIProviders /> },
  { key: 'backup', label: 'Backup & Restore', render: () => <BackupRestore /> },
];

const AppConfiguration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromQuery = new URLSearchParams(location.search).get('tab');
  const [tab, setTab] = useState(TABS.some((t) => t.key === fromQuery) ? fromQuery : 'general');

  useEffect(() => {
    if (fromQuery && fromQuery !== tab && TABS.some((t) => t.key === fromQuery)) setTab(fromQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromQuery]);

  const open = (key) => {
    setTab(key);
    navigate(`/settings?tab=${key}`, { replace: true });
    window.scrollTo(0, 0);
  };

  const active = TABS.find((t) => t.key === tab) || TABS[0];
  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <h2 className="page-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><FaCog /> App Configuration</h2>
        <p className="page-subtitle">Branding, company and units, compliance controls, reports, numbering, roles, approvals, alerts and system services. Commercial plan, limits and license are in Commercial Setup.</p>
      </div>
      <div className="lms-tabs" style={{ marginBottom: '16px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
        {TABS.map((t) => (
          <button key={t.key} type="button" className={`lms-tab ${tab === t.key ? 'active' : ''}`} onClick={() => open(t.key)}>{t.label}</button>
        ))}
      </div>
      <div key={active.key}>{active.render()}</div>
    </div>
  );
};

export default AppConfiguration;
